import apiClient from 'services/axios'
import ApiConfig from 'services/config';
import errorHandler from 'components/error.handler';

const { PromotionConfig } = ApiConfig;

export async function createPromotion(body) {
  const { businessCode } = body
  const { id = '' } = body
  delete body.businessCode
  if (id) delete body.id
  return apiClient[id ? 'put' : 'post'](PromotionConfig.PROMOTIONS.replace(':id', id).concat(businessCode), body)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(({ data }) => {
      errorHandler(data)
    })
}

export async function updatePromotionStatus(body) {
  const { businessCode } = body
  const { id } = body
  delete body.businessCode
  if (id) delete body.id
  return apiClient.patch(PromotionConfig.PROMOTIONS.replace(':id', id).concat(businessCode), body)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(({ data }) => {
      errorHandler(data)
    })
}

export async function showPromotions(businessCode) {
  return apiClient
    .get(PromotionConfig.PROMOTIONS.replace(':id', '').concat(businessCode))
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}
